"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.plusOneFormUtils = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const app_1 = require("app");
const Forms_1 = require("../Forms");
const CheckBox_1 = require("../CheckBox");
const ModalDialog_1 = require("../../Components/ModalDialog");
const types_1 = require("./types");
class PlusOneFormUtils {
    constructor() {
        this.renderMessageModal = (component, selector, title, classes, popupAriaLabel, closeButtonAriaLabel, onModalClose) => {
            const additionalModalParameters = {
                classes,
                onModalClose,
                popupAriaLabel,
                closeButtonAriaLabel,
                backdrop: 'static',
            };
            (0, ModalDialog_1.RenderModal)(component, selector, title, additionalModalParameters);
        };
        this.generateInputs = (input, stateValue, onChange) => {
            const { label, type, required, name, hint, errorMessage } = input;
            const isDropdown = type === types_1.InputType.SELECT;
            const options = isDropdown ? this.generateOptions() : [];
            const queryParam = exports.plusOneFormUtils.getParameterByName(types_1.UrlInputNames[name]);
            const isDisabled = isDropdown ? (0, Forms_1.getOptionTitleByValue)(options, queryParam) : queryParam;
            return {
                name,
                placeholder: isDropdown ? 'Select option' : label,
                label: label,
                errorMessage,
                hint,
                onChange,
                value: stateValue.value,
                hasError: stateValue.hasError,
                hasFormatError: false,
                formatErrorMessage: '',
                required: Boolean(required),
                disabled: isDisabled,
                options,
            };
        };
        this.generateOptions = (options = []) => {
            Object.keys(types_1.plusOneProductOptions).map((optionName) => {
                options.push({
                    title: types_1.plusOneProductOptions[optionName].title,
                    value: types_1.plusOneProductOptions[optionName].value,
                    hidden: types_1.plusOneProductOptions[optionName].hidden,
                });
            });
            return options;
        };
        this.renderModalBody = () => {
            return (0, jsx_runtime_1.jsx)("div", { children: "This is modal body" });
        };
        this.getInitialState = (stateObject = {}) => {
            Object.values(types_1.InputName).map(name => {
                stateObject[String(name).toLocaleLowerCase()] = {
                    hasError: false,
                    value: exports.plusOneFormUtils.getParameterByName(types_1.UrlInputNames[name]) || '',
                };
            });
            return Object.assign(Object.assign({}, stateObject), { checkbox: 'false', file: {
                    hasError: false,
                    value: '',
                }, formValid: false, fileName: '' });
        };
        this.validateFileSize = (size, megabyte = 1024000, limit = 4) => {
            const currentSize = size / megabyte;
            return currentSize < limit;
        };
        this.convertInputs = (input, userconsent, userConsentValidationText, formInputRef, prepareInputData, handleOnChange, handleCheckboxChange) => {
            const { type, label, errorMessage } = input;
            const inputData = prepareInputData(input, handleOnChange);
            switch (type) {
                case types_1.InputType.INPUT:
                    return (0, jsx_runtime_1.jsx)(Forms_1.FormInput, Object.assign({}, inputData));
                case types_1.InputType.TEXTAREA:
                    return (0, jsx_runtime_1.jsx)(Forms_1.FormTextarea, Object.assign({}, inputData));
                case types_1.InputType.SELECT:
                    return (0, jsx_runtime_1.jsx)(Forms_1.FormDropdown, Object.assign({}, inputData));
                case types_1.InputType.CHECKBOX:
                    return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)("p", { className: "plus-one-form-consent prose prose-danfoss [&_*]:!my-0 mt-2 md:mt-4", children: (0, app_1.StringToHTML)(label) }), (0, jsx_runtime_1.jsx)(CheckBox_1.Checkbox, { labelText: userConsentValidationText, isSelected: userconsent.value, hasError: userconsent.hasError, onClick: e => handleCheckboxChange(e), validationMessage: errorMessage, formControlRef: formInputRef, className: "mt-6 md:mt-8" })] }));
            }
        };
        this.resetFormValues = (state, resetValues = {}) => {
            Object.values(types_1.InputName).forEach(name => {
                resetValues[String(name).toLocaleLowerCase()] = Object.assign(Object.assign({}, state), { value: exports.plusOneFormUtils.getParameterByName(types_1.UrlInputNames[name]) || '' });
            });
            return resetValues;
        };
    }
    getParameterByName(name, url = window.location.href) {
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        const results = regex.exec(url);
        if (!results)
            return null;
        if (!results[2])
            return '';
        return decodeURIComponent(results[2]);
    }
    getCurrentOptionValue(text) {
        Object.values(types_1.plusOneProductOptions).map((optionName) => (text = optionName.value === text ? optionName.title : text));
        return text;
    }
}
exports.plusOneFormUtils = new PlusOneFormUtils();
